import React, { Suspense } from 'react';

import MainLayout from '../components/MainLayout';

import { navigations } from '../config/constants';

import { useStateValue } from '../state';

export default () => {
  const ButtonNavigation = React.lazy(() => import('../components/ButtonNavigation'));
  const [, dispatch] = useStateValue();
  const onClick = (evt, typeValue) => {
    const opts = {
      info() {
        evt.preventDefault();

        dispatch({
          type: 'MODAL_SET',
          payload: {
            show: true,
            target: null,
            type: 'info',
          },
        });
      },
    };

    return opts[typeValue]();
  };

  return (
    <MainLayout>
      <div className="page--banner">
        <img src="/images/good-cup.svg" alt="" />
        <h6>#LetsBrewBetter</h6>
      </div>
      <div className="page--header">
        <div className="page--header-index">
          <h3 className="page--header-index-title">
            Hello there
            {' '}
            <span role="img" aria-label="wave">👋</span>
          </h3>
          <p className="page--header-index-sub">
            Select the roast type of the beans you have purchased
          </p>
        </div>
      </div>
      <div className="page--body">
        <div className="page--body-navigation">
          {navigations.map(navigation => (
            <Suspense fallback={null} key={navigation.key}>
              <ButtonNavigation navigation={navigation} />
            </Suspense>
          ))}
        </div>
      </div>
      <div className="page--footer">
        <a
          className="page--footer-link"
          href="!#"
          onClick={(evt) => onClick(evt, 'info')}
        >
          How do I know my roast type?
        </a>
      </div>
    </MainLayout>
  );
}
